import React from 'react';
import { Route, Redirect } from 'react-router';
import { observer } from 'mobx-react';

import UserStore from 'stores/UserStore';

export default observer(({ component: Component, area = 'public', ...rest }) => {
  const authed = UserStore.isAuthenticated && UserStore.allowedAreas.indexOf(area) > -1;

  return (
    <Route
      {...rest}
      render={(props) =>
        authed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: UserStore.homePage,
              state: { from: props.location }
            }}
          />
        )}
    />
  );
});



// WEBPACK FOOTER //
// ./src/routes/SecureRoute.jsx